module.exports = __webpack_public_path__ + "static/img/bg_pc1.5e8eace5.jpg";